import React from 'react';
import MUITabs from '@mui/material/Tabs';
import MUITab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';

export const Tabs = ({ tabs = [], defaultTab, completedTabs = 0, tabProps = {} }) => {
    const [currentTab, setCurrentTab] = React.useState(() => {
        if (defaultTab) {
            if (!Number.isNaN(+defaultTab)) {
                if (+defaultTab - 1 > completedTabs) return completedTabs;
                else return Math.max(Math.min(+defaultTab - 1, tabs.length - 1), 0);
            }

            return tabs.findIndex(({ id }) => id === defaultTab) || 0;
        }

        return 0;
    });

    const handleChange = newcurrentTab => {
        if (newcurrentTab < 0 || newcurrentTab > tabs.length - 1) return;
        setCurrentTab(newcurrentTab);
    };

    return (
        <>
            <Box className='tw-border-b tw-border-gray-600'>
                <MUITabs
                    value={currentTab}
                    onChange={(_e, val) => handleChange(val)}
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'black'
                        },
                        '& .MuiTabs-flexContainer': {
                            display: 'flex',
                            justifyContent: {
                                xs: 'space-between',
                                sm: 'flex-start'
                            }
                        }
                    }}
                >
                    {tabs.map(({ label, className, iconClass }, index) => (
                        <MUITab
                            key={label}
                            label={
                                <>
                                    {completedTabs < tabs.length ? (
                                        <span
                                            className={cn([
                                                ` tw-text-white tw-rounded-full tw-aspect-square tw-flex tw-items-center tw-justify-center`,
                                                currentTab === index ? 'tw-bg-black' : 'tw-bg-gray-600',
                                                iconClass || 'tw-min-w-8 tw-font-[700] tw-text-[16px]'
                                            ])}
                                        >
                                            {index + 1}
                                        </span>
                                    ) : null}
                                    <span
                                        className={cn([
                                            ` tw-text-left tw-break-words tw-whitespace-normal`,
                                            currentTab !== index ? 'tw-d-none sm:tw-inline' : ''
                                        ])}
                                    >
                                        {label}
                                    </span>
                                </>
                            }
                            id={`simple-tab-${index}`}
                            aria-controls={`simple-tabpanel-${index}`}
                            className={cn([
                                'tw-text-[16px] tw-min-w-[unset] tw-flex tw-gap-[8px] tw-items-center tw-capitalize tw-max-w-[190px] sm:tw-max-w-[unset] tw-flex-row',
                                currentTab === index ? '!tw-text-black' : '!tw-text-gray-600',
                                className
                            ])}
                        />
                    ))}
                </MUITabs>
            </Box>
            {tabs.map(({ label, Component }, index) => (
                <div
                    key={label}
                    role='tabpanel'
                    hidden={currentTab !== index}
                    id={`simple-tabpanel-${index}`}
                    aria-labelledby={`simple-tab-${index}`}
                >
                    <Component onTabChange={handleChange} currentTab={currentTab} {...tabProps} />
                </div>
            ))}
        </>
    );
};

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.object),
    tabProps: PropTypes.object,
    defaultTab: PropTypes.string,
    completedTabs: PropTypes.number
};
